// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610120621/js/" + chunkId + "." + {"44":"4e4e95a0","225":"4696817c","481":"3bbab9ba","486":"64169a92","770":"5a8de9ce"}[chunkId] + ".0.058428046163017555.chunk.js";
};